import { DxFormGroup } from '../form-group';
import { ON_SET_VALUE_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';
import { Without } from '@digitaix/types';

export function OnSetValue<T>(...controlPaths: Array<string>) {
  return function(
    target: Partial<Without<T, keyof DxFormGroup<any>>>,
    propertyKey: string
  ) {
    addToMetadata(
      ON_SET_VALUE_KEY,
      {
        controlPaths,
        propertyKey
      },
      target
    );
  };
}
